import { Button } from 'react-bootstrap';

Button.defaultProps = {
    className: "rounded-0 px-2"
};

export default Button;